import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  const columns = t("footer.columns");

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1814] text-white border-t border-white/10 relative overflow-hidden"
    >
      <div
        className="absolute -top-32 -right-32 w-[460px] h-[460px] opacity-25 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(67,125,234,0.5) 0%, transparent 70%)",
          filter: "blur(50px)",
        }}
      />

      <div className="container-iko relative pt-16 lg:pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16">
          {/* Brand */}
          <div className="md:col-span-6">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="relative w-8 h-8 rounded-2xl bg-[#0A0810] flex items-center justify-center overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_lumirun-agency/artifacts/z78wj5mo_LinkedIn-400px-logo-L-blanc-fond-noir.png"
                  alt="Lumiron"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="font-display text-xl font-semibold tracking-tighter">iko</span>
            </div>
            <p className="font-display text-lg lg:text-xl max-w-sm text-white/80 leading-snug tracking-[-0.02em]">
              {t("footer.tagline")}
            </p>
            <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
              {t("footer.made")}
            </div>
          </div>

          {/* Columns */}
          <div className="md:col-span-6 grid grid-cols-2 gap-8">
            {columns.map((col, i) => (
              <div key={i}>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50 mb-4">
                  {col.title}
                </div>
                <ul className="space-y-2.5">
                  {col.links.map((link, j) => {
                    const className =
                      "text-[14px] text-white/75 hover:text-white transition-colors";
                    return (
                      <li key={j}>
                        {link.to ? (
                          <Link to={link.to} className={className}>
                            {link.label}
                          </Link>
                        ) : (
                          <a href={link.href} className={className}>
                            {link.label}
                          </a>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 relative">
        <div className="container-iko py-5 flex flex-col sm:flex-row items-center justify-between gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
          <div>© {new Date().getFullYear()} iko · {t("footer.rights")}</div>
          <div>v1.0</div>
        </div>
      </div>
    </footer>
  );
}
